import { Locale } from '@headless-workspace/config';
import { HTMLString } from '@headless-workspace/domain/common/server';
import { CTA } from '@headless-workspace/glow-ds';
import { UrlHelpers } from '@headless-workspace/utils';
import { HomeProductRecommendationsDTO, HomeSlotBase, HomeSlotType, mapHomeSlotBase } from '../../../../server';

export type HomeCarouselValue = HomeSlotBase & {
    type: HomeSlotType.ProductRecommendations;
    title: HTMLString;
    cta?: CTA;
    productsIds: string[];
};

export const mapHomeCarousel = (dto: HomeProductRecommendationsDTO): HomeCarouselValue => {
    return {
        ...mapHomeSlotBase(dto),
        type: HomeSlotType.ProductRecommendations,
        title: dto.details.title ? HTMLString(dto.details.title) : HTMLString(''),
        cta:
            dto.details.cta?.label && dto.details.cta?.link
                ? {
                      label: dto.details.cta.label,
                      href: UrlHelpers.getHrefPathname(dto.details.cta.link),
                  }
                : undefined,
        productsIds: dto.details.productsIds,
    };
};
